export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10027.257d0b63.jpg";